import { ReloadOutlined } from '@ant-design/icons';
import { Row } from 'antd';
import Information from 'assets/images/driver-portal/information.svg';
import { Button } from 'components';
import { theme } from 'configs/styled';
import React from 'react';
import DriverPortalLayout from '../components/DriverPortalLayout';
import { ImageLogo } from '../components/HeaderPortal.style';
import TextRegular from '../components/TextRegular';
import Title from '../components/Title';
import HeaderPortal from './components/HeaderPortal';

const ErrorPage: React.FC = () => {
  return (
    <>
      <HeaderPortal disabledDivider />
      <DriverPortalLayout>
        <Row justify="center" style={{ margin: `${theme.spacing.xxl} 0` }}>
          <ImageLogo
            style={{ marginRight: theme.spacing.xs }}
            src={Information}
          />
        </Row>
        <Row justify="center">
          <Title>เกิดข้อผิดพลาดบางประการ</Title>

          <div
            style={{
              margin: `0 0 ${theme.spacing.xxl} 0px`,
              textAlign: 'center',
            }}
          >
            <TextRegular>
              ขออภัย เกิดข้อผิดพลาดบางประการทำให้ไม่สามารถดำเนินการต่อได้
              ทางเรากำลังดำเนินการแก้ไขอย่างเร็วที่สุด คุณสามารถรีเฟรชหน้า
              และดำเนินการต่ออีกครั้งในภายหลัง
            </TextRegular>
          </div>

          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={() => window.location.reload()}
          >
            ลองอีกครั้ง
          </Button>
        </Row>
      </DriverPortalLayout>
    </>
  );
};

export default ErrorPage;
